import { css } from '@emotion/css'
import { spacing, colors, shorthandHelper } from '@offerzen/pinata-shame'

const styles = {
  workHistory: css({
    display: 'flex',
    justifyContent: 'space-between',
    paddingBottom: spacing.default,
    marginBottom: spacing.medium,
    borderBottom: `1px dashed ${colors.mystic}`,
  }),

  text: css({
    display: 'flex',
    flexDirection: 'column',

    '& > * + *': {
      marginTop: spacing.small,
    },
  }),

  actions: css({
    display: 'flex',
    alignItems: 'center',

    '& > * + *': {
      marginLeft: spacing.small,
    },
  }),

  button: css({
    minWidth: 70,
  }),

  footer: css({
    display: 'flex',
    justifyContent: 'space-between',
    borderTop: `1px solid ${colors.mystic}`,
    margin: shorthandHelper([spacing.default, -spacing.large, -spacing.small, -spacing.large]),
    padding: shorthandHelper([spacing.medium, spacing.large, 0, spacing.large]),
  }),
}

export default styles
